const isFirstVersionGreater = (ver1: string, ver2: string): boolean => _compare(ver1, ver2) === 1;

const isFirstVersionGreaterOrEqual = (ver1: string, ver2: string): boolean => {
    const comparisonResult = _compare(ver1, ver2);

    return comparisonResult === 1 || comparisonResult === 0;
};

const isFirstVersionLess = (ver1: string, ver2: string): boolean => _compare(ver1, ver2) === -1;

const isFirstVersionLessOrEqual = (ver1: string, ver2: string): boolean => {
    const comparisonResult = _compare(ver1, ver2);

    return comparisonResult === -1 || comparisonResult === 0;
};

const isFirstVersionEqual = (ver1: string, ver2: string): boolean => {
    const comparisonResult = _compare(ver1, ver2);

    return comparisonResult === 0;
};

const _compare = (ver1: string, ver2: string): number | undefined => {
    if (ver1 && ver2) {
        return ver1.localeCompare(ver2, undefined, {
            numeric: true,
            sensitivity: 'base',
        });
    }
    return;
};

export default {
    isFirstVersionEqual,
    isFirstVersionGreater,
    isFirstVersionGreaterOrEqual,
    isFirstVersionLess,
    isFirstVersionLessOrEqual,
};
